import apiPaths from '../api-paths.js';

export default {
  index(query = '') {
    return axios.get(`${ apiPaths.CRM }/subscription-settlements${ query }`);
  },
  indexByAgreement(id) {
    return axios.post(`${ apiPaths.CRM }/subscription-settlements/indexSettlementsByAgreementId/${ id }`);
  },
  delete(id) {
    return axios.delete(`${ apiPaths.CRM }/subscription-settlements/${ id }`);
  },
  open(id) {
    return axios.post(`${ apiPaths.CRM }/subscription-settlements/open/${ id }`);
  },
  close(id) {
    return axios.post(`${ apiPaths.CRM }/subscription-settlements/close/${ id }`);
  },
  generateForPeriod({ period }) {
    return axios.post(`${ apiPaths.CRM }/subscription-settlements/generate-for-period`, { period });
  },
  sendInvoices() {
    return axios.get(`${ apiPaths.CRM }/subscription-settlements/sendInvoices`);
  },
};
